import { Typography } from "@mui/material";
import clsx from "clsx";
import generateTailwindVariableClasses from "@/Common/helpers/TailwindCSS";
import { TypographyHeaderProps } from "../types";

export function TypographyHeader({
	children,
	params,
	right = false,
	left = false,
	center = false,
	...props
}: Readonly<TypographyHeaderProps>) {
	const { fontSize = "12px", fontLineHeight = "12px", lineClamp = "2" } = props;
	return (
		<Typography
			variant={"appBody1"}
			className={clsx({
				[`${props.className ?? ""}`]: true,
				"!font-montserrat !text-[color:--text-color] !font-medium": true,
				"!text-[length:--font-size-param] !leading-[--font-line-height-param]": true,
				"line-clamp-[--line-clamp-param]": lineClamp?.length,
				"!mt-[3px] truncate text-balance": true,
				"w-[600px] text-right": right,
				"w-[600px] text-left": left,
				"w-[600px] text-center": center,
				"!pb-[1px]": true,
			})}
			style={{
				...generateTailwindVariableClasses("--font-size-param", fontSize),
				...generateTailwindVariableClasses("--font-line-height-param", fontLineHeight),
				...generateTailwindVariableClasses("--line-clamp-param", lineClamp),
			}}
		>
			{children ?? params?.colDef.headerName ?? ""}
		</Typography>
	);
}
